
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Support",
      function () {
        return require("private-next-pages/Support.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Support"])
      });
    }
  